import dayjs from "dayjs";

import type { IDiscountCampaignConfig } from "app/components/discountCampaign/DiscountBanner/types/discountCampaignConfig";
import {
    FIRST_WEEK_CAMPAIGN_CONFIG,
    FIRST_WEEK_MONTHLY_CAMPAIGN_CTA,
    FIRST_WEEK_PROMO_CODE,
    FIRST_WEEK_PROMO_CODES_WITH_UPGRADE_TO_ANNUAL,
} from "app/components/FirstWeekMonthlyPromo/configs/FirstWeekCampaignConfig";
import { isFirstWeekCampaignEligible } from "app/components/FirstWeekMonthlyPromo/utils/campaignTypes";

export const FIRST_WEEK_CAMPAIGN_ID = "firstweek";

export const buildFirstWeekDiscountCampaignConfig = (): IDiscountCampaignConfig => ({
    id: FIRST_WEEK_CAMPAIGN_ID,
    bannerStorageKey: "first.week.campaign.banner.last.shown",
    bannerTrackingPrefix: "first week campaign banner",
    bannerCtaType: FIRST_WEEK_MONTHLY_CAMPAIGN_CTA,
    getDiscountDateConfig: (subscriptionDateStart: string) => ({
        startDate: subscriptionDateStart,
        endDate: dayjs(subscriptionDateStart).add(7, "day").format("YYYY-MM-DD"),
    }),
    isEligible: isFirstWeekCampaignEligible,
    annualPromoCodes: FIRST_WEEK_PROMO_CODES_WITH_UPGRADE_TO_ANNUAL,
    getBannerConfig: () => FIRST_WEEK_CAMPAIGN_CONFIG.banner,
    getModalConfig: () => FIRST_WEEK_CAMPAIGN_CONFIG.modal,
    getPromoCode: () => FIRST_WEEK_PROMO_CODE,
});
